var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"detail-model",style:(`
  background: ${_vm.dataSource.background};
  height: ${_vm.$px2rem(_vm.dataSource.height)};
`),attrs:{"data-h":_vm.dataSource.height}},_vm._l((_vm.dataSource.images),function(item,index){return _c('div',{key:index,style:(`
        width: ${_vm.$px2rem(1200)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
      `)},[(!item.isbg && typeof item.url === 'string')?_c('LazyImg',{attrs:{"className":"img side","styles":`
        width: ${_vm.$px2rem(item.width)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
        top: ${_vm.$px2rem(item.top)};
        transform: translateX(${_vm.$px2rem(item.moveX)});
      `,"src":item.url}}):_vm._e(),_vm._v(" "),(!item.isbg && typeof item.url !== 'string')?_c('div',{staticClass:"swiper-box",style:(`
          width: ${_vm.$px2rem(item.width)};
          height: ${_vm.$px2rem(item.height)};
          top: ${_vm.$px2rem(item.top)};
          left: ${_vm.$px2rem(item.left)};
          z-index: ${item.zIndex};
        `)},[_c('swiper',{ref:"swiper",refInFor:true,style:(`
          width: ${_vm.$px2rem(item.width)};
        height: ${_vm.$px2rem(item.height)};
        `),attrs:{"options":item.disableAutoPlay ? _vm.disableAutoPlaySwiperOptions : _vm.swiperOptions}},_vm._l((item.url),function(it,i){return _c('swiper-slide',{key:i,style:(`
              width: ${_vm.$px2rem(item.width)};
              height: ${_vm.$px2rem(item.height)};
            `)},[_c('img',{style:(`
              width: ${_vm.$px2rem(item.width)};
              height: ${_vm.$px2rem(item.height)};
            `),attrs:{"src":it}})])}),1),_vm._v(" "),_c('i',{ref:"prev",refInFor:true,class:`
            iconfont 
            ${_vm.upBtnHover ? 'iconbanner_switch_hover_ic' : 'iconbanner_switch_ic'} 
            swiper-progress-up
          `,on:{"click":function($event){return _vm.onSwiper('slidePrev')},"mouseover":function($event){_vm.upBtnHover = true},"mouseout":function($event){_vm.upBtnHover = false}}}),_vm._v(" "),_c('i',{ref:"next",refInFor:true,class:`
            iconfont 
            ${_vm.nextBtnHover ? 'iconbanner_switch_hover_ic' : 'iconbanner_switch_ic'} 
            swiper-progress-next
          `,on:{"click":function($event){return _vm.onSwiper('slideNext')},"mouseover":function($event){_vm.nextBtnHover = true},"mouseout":function($event){_vm.nextBtnHover = false}}})],1):_vm._e(),_vm._v(" "),(item.isbg)?_c('img',{staticClass:"img img-bg",style:(`
        width: ${_vm.$px2rem(item.width)};
        height: ${_vm.$px2rem(item.height)};
        z-index: ${item.zIndex};
        top: ${_vm.$px2rem(item.top)};
        transform: translateX(${_vm.$px2rem(item.moveX)});
      `),attrs:{"src":item.url}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }